import gql from 'graphql-tag'

/**
 * This is a utility function takes simple input object and map it into VoucherCreateInput
 * @param input Un mapped voucher input
 */
export const VoucherCreateInputMap = (
  input: VoucherInput
): VoucherCreateInput => {
  //@ts-ignore
  const mappedInput: VoucherCreateInput = { ...input }

  if (input.department) {
    mappedInput.department = {
      connect: {
        id: input.department,
      },
    }
  }

  if (input.created_by) {
    mappedInput.created_by = {
      connect: {
        id: input.created_by,
      },
    }
  }

  if (input.pay_to) {
    mappedInput.pay_to = {
      connect: {
        id: input.pay_to,
      },
    }
  }

  if (input.claimed_by) {
    mappedInput.claimed_by = {
      connect: {
        id: input.claimed_by,
      },
    }
  }
  mappedInput.voucher_cost_category = {
    create: input.voucher_cost_category.map((category) => {
      return {
        cost_category: {
          connect: {
            id: category.cost_category.id,
          },
        },
        cost_share: category.cost_share,
      }
    }),
  }

  return mappedInput
}

export const CREATE_VOUCHER = gql`
  mutation Voucher($input: VoucherCreateInput) {
    createVoucher(input: $input) {
      description
      department
      total_amount
      paid_by_amin
      receivers_account_number
      pay_to {
        id
        first_name
        last_name
      }

      claimed_by {
        id
        first_name
        last_name
      }

      created_by {
        id
        first_name
        last_name
      }
      voucher_cost_category {
        id
        cost_share
        cost_category {
          id
          name
          code
          parent_id
        }
      }
    }
  }
`

export type VoucherInput = {
  description: string
  department: string
  total_amount: number
  receivers_account_number: string
  created_by?: string
  claimed_by?: string
  pay_to?: string
  voucher_cost_category: inputCostCategory[]
}

export type VoucherCreateInput = {
  description: string
  department: Connect
  receivers_account_number: string
  created_by: Connect
  claimed_by: Connect
  pay_to: Connect
  voucher_cost_category: {
    create: voucherCostCategory[]
  }
}

export const APPROVE_VOUCHER = gql`
  mutation Voucher($input: ApproveInput) {
    approve(input: $input) {
      voucher_id
      status
      approved_at
      comment
      approver {
        id
        email
      }
    }
  }
`

export type ApproveInput = {
  voucherId: string
  status: string
  comment: string | null
}

export const REJECT_VOUCHER = gql`
  mutation Voucher($input: RejectInput) {
    reject(input: $input) {
      id
      reference_number
    }
  }
`

export type RejectInput = {
  voucherId: string
  comment: string
}

export const PAID_VOUCHER = gql`
  mutation Voucher($input: PaidInput) {
    paid(input: $input) {
      id
      payment_reference
      paid_by_amin
      expense_period
    }
  }
`

export type PaidInput = {
  voucher_id: string
  payment_reference: string
  paid_by_amin: string
  expense_period: number
}

type voucherCostCategory = {
  cost_category: Connect
  cost_share: number
}
type Connect = {
  connect: {
    id: string
  }
}
type inputCostCategory = {
  cost_category: { id: string }
  cost_share: number
}

export const GET_INBOX = gql`
  query getInbox {
    inbox {
      id
      reference_number
      description
      total_amount
      international_payment
      currency
      paid_by_amin
      expense_period
      receivers_account_number
      state
      created_at
      pay_to
      claimed_by {
        id
        first_name
        last_name
      }
      created_by {
        id
        first_name
        last_name
      }
      department {
        id
        name
      }
      voucher_approvals {
        approved_at
        status
        comment
        order_number
        approver {
          id
          email
          first_name
          last_name
          majlis
          user_role {
            id
            name
            scope
          }
        }
        approval_stage {
          id
          is_payment_stage
        }
      }
      voucher_cost_category {
        cost_share
        cost_category {
          name
          code
          parent {
            name
          }
        }
        receipts {
          id
          path
        }
      }
      workflow {
        id
      }
    }
  }
`
